import React, { useEffect, useRef, useState } from 'react'

interface Props {
  children: React.ReactNode
  animationClass?: string
}

const FadeInOnScroll: React.FC<Props> = ({ children, animationClass = 'animate-fadeinup' }) => {
  const ref = useRef<HTMLDivElement | null>(null)
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true)
          observer.disconnect() // Solo lo animamos una vez
        }
      },
      {
        threshold: 0.8// Visible al menos un 80%
      }
    )

    if (ref.current !== null) {
      observer.observe(ref.current)
    }

    return () => {
      observer.disconnect()
    }
  }, [])

  return (
    <div
      ref={ref}
      className={`${isVisible ? animationClass : 'opacity-0'} transition-opacity duration-1000`}
    >
      {children}
    </div>
  )
}

export default FadeInOnScroll
